export default "__VITE_ASSET__BILeSmrJ__"